import { getIsCountryCompliant } from '@src/modules/global-state/locale-config.browser'

import checkForWordInURL from './checkForWordInURL'
import { ANALYTIC_COOKIES } from './constants'
import {
  getUtmValues,
  initAnalyticsCookieFromCrossPlatformData,
} from './cross-platform-analytics/cross-platform-analytics.utils'
import eraseCookie from './eraseCookie'
import extractDomainFromURL from './extractDomainFromURL'
import getCurrentUser from './getCurrentUser'
import { getlbUserId } from './getlb-user-id'
import isBrowser from './isBrowser'
import setCookie from './setCookie'

function initUserAnalyticsCookie() {
  if (!isBrowser()) return
  initAnalyticsCookieFromCrossPlatformData()
  captureCampaignParams()

  const user = getCurrentUser()
  // UK (countryCompliant): never persist raw email to a cookie. US/CA unchanged.
  if (user?.email && !getIsCountryCompliant()) {
    setCookie(ANALYTIC_COOKIES.LB_CUSTOMER_EMAIL, user.email)
  }
  getlbUserId()
}
export default initUserAnalyticsCookie

export function determineUtmCookieActions(
  utmParams: {
    utmCampaign: string | null
    utmContent: string | null
    utmMedium: string | null
    utmSource: string | null
    utmTerm: string | null
    qclid: string | null
  },
  referrer: string,
) {
  const { utmCampaign, utmContent, utmMedium, utmSource, utmTerm, qclid } = utmParams

  // If utmSource exists, we need to handle UTM parameters
  if (utmSource) {
    return {
      utmSource: utmSource,
      utmContent: utmContent,
      utmTerm: utmTerm,
      utmMedium: utmMedium,
      utmCampaign: utmCampaign,
      qclid: qclid,
    }
  }

  // If no utmSource, check for organic referrer
  const domain = extractDomainFromURL(referrer)

  if (
    domain &&
    // eslint-disable-next-line i18next/no-literal-string
    !checkForWordInURL(referrer, 'apay-us.amazon') &&
    !['lastbrand', 'onequince', 'quince', 'localhost', 'myshopify', 'shopify', 'paypal', 'klarnapayments'].includes(
      domain,
    )
  ) {
    return {
      utmSource: domain,
      // eslint-disable-next-line i18next/no-literal-string
      utmMedium: 'organic',
      utmContent: null,
      utmTerm: null,
      utmCampaign: null,
      qclid: null,
    }
  }

  // No UTM parameters or valid referrer
  return {
    utmSource: null,
    utmContent: null,
    utmTerm: null,
    utmMedium: null,
    utmCampaign: null,
    qclid: null,
  }
}

function captureCampaignParams() {
  const utmParams = getUtmValues()
  const referrer = (isBrowser() && document.referrer) || ''
  const cookieActions = determineUtmCookieActions(utmParams, referrer)
  const isSecure = isBrowser() ? window.location.protocol === 'https:' : true
  // Apply cookie actions
  if (cookieActions.utmSource) {
    setCookie(ANALYTIC_COOKIES.UTM_SOURCE, cookieActions.utmSource, 120, isSecure)
  } else {
    eraseCookie(ANALYTIC_COOKIES.UTM_SOURCE)
  }

  if (cookieActions.utmContent) {
    setCookie(ANALYTIC_COOKIES.UTM_CONTENT, cookieActions.utmContent, 120, isSecure)
  } else {
    eraseCookie(ANALYTIC_COOKIES.UTM_CONTENT)
  }

  if (cookieActions.utmTerm) {
    setCookie(ANALYTIC_COOKIES.UTM_TERM, cookieActions.utmTerm, 120, isSecure)
  } else {
    eraseCookie(ANALYTIC_COOKIES.UTM_TERM)
  }

  if (cookieActions.utmMedium) {
    setCookie(ANALYTIC_COOKIES.UTM_MEDIUM, cookieActions.utmMedium, 120, isSecure)
  } else {
    eraseCookie(ANALYTIC_COOKIES.UTM_MEDIUM)
  }

  if (cookieActions.utmCampaign) {
    setCookie(ANALYTIC_COOKIES.UTM_CAMPAIGN, cookieActions.utmCampaign, 120, isSecure)
  } else {
    eraseCookie(ANALYTIC_COOKIES.UTM_CAMPAIGN)
  }

  if (cookieActions.qclid) {
    setCookie(ANALYTIC_COOKIES.QCLID, cookieActions.qclid, 120, isSecure)
  } else {
    eraseCookie(ANALYTIC_COOKIES.QCLID)
  }
}
